import { render, staticRenderFns } from "./warehouseSelect.vue?vue&type=template&id=80bb2aba&scoped=true&"
import script from "./warehouseSelect.vue?vue&type=script&lang=js&"
export * from "./warehouseSelect.vue?vue&type=script&lang=js&"
import style0 from "./warehouseSelect.vue?vue&type=style&index=0&id=80bb2aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bb2aba",
  null
  
)

export default component.exports